import { useNavigate } from 'react-router-dom';
import { Button } from '@mantine/core';
import { documentTemplateEditPath } from '@dealstack/frontend/app/pages/DocumentTemplates/ManageDocumentTemplates.routes';

interface Props {
	templateId: string;
}

export const EditTemplateButton = ({ templateId }: Props) => {
	const navigate = useNavigate();

	return (
		<Button
			variant="ghost"
			onClick={() => {
				navigate(documentTemplateEditPath(templateId));
			}}
		>
			Edit
		</Button>
	);
};
